import {Url} from '@/utils/url';
import get from 'lodash/get';

const InitProductAttributes = {
  created() {
    this.initProductAttributes();
  },

  methods: {
    /**
     * Initialize selected attributes if variant ID has been passed in URL string.
     * @return {boolean}
     */
    selectVariantFromQueryString() {
      const queryProductId = get(window.location.href.match(/\/p\/([a-zA-Z0-9-]+)\//i), '[1]', '');
      if (!queryProductId || !this.product.variants || this.product.code === queryProductId) {
        return false;
      }

      let setFromVariant = false;
      const setInitProductAttributes = (items, parents = []) => {
        if (!items || !items.length) {
          return;
        }

        for (let item of items) {
          const productCode = get(item, 'options.productCode');
          if (productCode && productCode === queryProductId) {
            setFromVariant = true;
            [...parents, item].forEach((item) => {
              this.$set(
                this.initAttributeSelection,
                item.code,
                item.options.colorSwatchName || item.options.displayName
              );
            });
          }

          setInitProductAttributes(item.children, [...parents, item]);
        }
      };

      setInitProductAttributes(this.product.categorizationHierarchyValues);
      return setFromVariant;
    },

    /**
     * Initialize selected attributes.
     */
    initProductAttributes() {
      if (!this.product.variants || !this.product.variants.length || this.selectVariantFromQueryString()) {
        return;
      }

      // Set default color
      const urlParams = Url.parse(window.location.search);
      const colorAttributeCode = get(this.product.categorizationHierarchyValues, '[0].code', '');
      let colorCode = '';

      if (urlParams && urlParams.colorCode) {
        colorCode = urlParams.colorCode;
      }

      if (!colorCode) {
        colorCode = get(this.product.categorizationHierarchyValues, '[0].options.colorSwatchName', '');
      } else {
        let foundColor = false;
        let variant = {};

        for (variant of this.product.categorizationHierarchyValues) {
          if (variant.options.colorSwatchName === colorCode) {
            foundColor = true;
            break;
          }
        }

        if (!foundColor) {
          colorCode = get(variant, '[0].options.colorSwatchName', '');
        }
      }

      this.$set(this.initAttributeSelection, colorAttributeCode, colorCode);
    },
  },

  data() {
    return {
      initAttributeSelection: {
        color: '',
      },
    };
  },
};

export {InitProductAttributes};
